var cov_2b2nsm30fd = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/Result.tsx",
      hash = "e19ad954bd145e706cad0e70d6c29da8aff15902",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/Result.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 36
        },
        end: {
          line: 18,
          column: 58
        }
      },
      "1": {
        start: {
          line: 26,
          column: 28
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "2": {
        start: {
          line: 27,
          column: 40
        },
        end: {
          line: 27,
          column: 62
        }
      },
      "3": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "4": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 113
        }
      },
      "5": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "6": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 12
        }
      },
      "7": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 13
        }
      },
      "8": {
        start: {
          line: 37,
          column: 26
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "9": {
        start: {
          line: 42,
          column: 40
        },
        end: {
          line: 42,
          column: 62
        }
      },
      "10": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 90
        }
      },
      "12": {
        start: {
          line: 45,
          column: 47
        },
        end: {
          line: 45,
          column: 90
        }
      },
      "13": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 98
        }
      },
      "14": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 27
        }
      },
      "15": {
        start: {
          line: 71,
          column: 15
        },
        end: {
          line: 71,
          column: 36
        }
      },
      "16": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "17": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "18": {
        start: {
          line: 73,
          column: 18
        },
        end: {
          line: 73,
          column: 34
        }
      },
      "19": {
        start: {
          line: 75,
          column: 19
        },
        end: {
          line: 75,
          column: 35
        }
      },
      "20": {
        start: {
          line: 76,
          column: 16
        },
        end: {
          line: 76,
          column: 70
        }
      },
      "21": {
        start: {
          line: 76,
          column: 57
        },
        end: {
          line: 76,
          column: 70
        }
      },
      "22": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 40
        }
      },
      "23": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "24": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 16
        }
      },
      "25": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "26": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 52
        }
      },
      "27": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 48
        }
      },
      "28": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 48
        }
      },
      "29": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 46
        }
      },
      "30": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 122,
          column: 37
        }
      },
      "31": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      },
      "32": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 102
        }
      },
      "33": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 29
        }
      },
      "34": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 62
        }
      },
      "35": {
        start: {
          line: 133,
          column: 35
        },
        end: {
          line: 133,
          column: 62
        }
      },
      "36": {
        start: {
          line: 137,
          column: 32
        },
        end: {
          line: 137,
          column: 42
        }
      },
      "37": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 140,
          column: 5
        }
      },
      "38": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 28
        }
      },
      "39": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 26
        }
      },
      "40": {
        start: {
          line: 145,
          column: 32
        },
        end: {
          line: 145,
          column: 42
        }
      },
      "41": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 79
        }
      },
      "42": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 22
        }
      },
      "43": {
        start: {
          line: 154,
          column: 51
        },
        end: {
          line: 154,
          column: 61
        }
      },
      "44": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "45": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "46": {
        start: {
          line: 157,
          column: 36
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "47": {
        start: {
          line: 159,
          column: 25
        },
        end: {
          line: 159,
          column: 119
        }
      },
      "48": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 171,
          column: 7
        }
      },
      "49": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 161,
          column: 24
        }
      },
      "50": {
        start: {
          line: 162,
          column: 13
        },
        end: {
          line: 171,
          column: 7
        }
      },
      "51": {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 36
        }
      },
      "52": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 169,
          column: 9
        }
      },
      "53": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 26
        }
      },
      "54": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 38
        }
      },
      "55": {
        start: {
          line: 176,
          column: 32
        },
        end: {
          line: 176,
          column: 38
        }
      },
      "56": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 31
        }
      },
      "57": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 24
        }
      },
      "58": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 22
        }
      },
      "59": {
        start: {
          line: 184,
          column: 25
        },
        end: {
          line: 184,
          column: 35
        }
      },
      "60": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 187,
          column: 10
        }
      },
      "61": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 23
        }
      },
      "62": {
        start: {
          line: 191,
          column: 72
        },
        end: {
          line: 191,
          column: 82
        }
      },
      "63": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 39
        }
      },
      "64": {
        start: {
          line: 192,
          column: 28
        },
        end: {
          line: 192,
          column: 39
        }
      },
      "65": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 198,
          column: 13
        }
      },
      "66": {
        start: {
          line: 195,
          column: 20
        },
        end: {
          line: 195,
          column: 42
        }
      },
      "67": {
        start: {
          line: 196,
          column: 18
        },
        end: {
          line: 196,
          column: 70
        }
      },
      "68": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 26
        }
      },
      "69": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 199,
          column: 20
        }
      },
      "70": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 27
        }
      },
      "71": {
        start: {
          line: 207,
          column: 88
        },
        end: {
          line: 207,
          column: 98
        }
      },
      "72": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 208,
          column: 35
        }
      },
      "73": {
        start: {
          line: 208,
          column: 24
        },
        end: {
          line: 208,
          column: 35
        }
      },
      "74": {
        start: {
          line: 209,
          column: 17
        },
        end: {
          line: 209,
          column: 42
        }
      },
      "75": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 222,
          column: 5
        }
      },
      "76": {
        start: {
          line: 216,
          column: 28
        },
        end: {
          line: 216,
          column: 81
        }
      },
      "77": {
        start: {
          line: 217,
          column: 28
        },
        end: {
          line: 217,
          column: 48
        }
      },
      "78": {
        start: {
          line: 226,
          column: 48
        },
        end: {
          line: 226,
          column: 58
        }
      },
      "79": {
        start: {
          line: 227,
          column: 17
        },
        end: {
          line: 227,
          column: 42
        }
      },
      "80": {
        start: {
          line: 228,
          column: 22
        },
        end: {
          line: 228,
          column: 77
        }
      },
      "81": {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 242,
          column: 5
        }
      },
      "82": {
        start: {
          line: 246,
          column: 42
        },
        end: {
          line: 246,
          column: 52
        }
      },
      "83": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 255,
          column: 5
        }
      },
      "84": {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 253,
          column: 7
        }
      },
      "85": {
        start: {
          line: 257,
          column: 4
        },
        end: {
          line: 257,
          column: 15
        }
      },
      "86": {
        start: {
          line: 274,
          column: 8
        },
        end: {
          line: 274,
          column: 18
        }
      },
      "87": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 293,
          column: 5
        }
      },
      "88": {
        start: {
          line: 297,
          column: 66
        },
        end: {
          line: 297,
          column: 76
        }
      },
      "89": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 301,
          column: 5
        }
      },
      "90": {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 300,
          column: 57
        }
      },
      "91": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 316,
          column: 5
        }
      },
      "92": {
        start: {
          line: 330,
          column: 8
        },
        end: {
          line: 330,
          column: 18
        }
      },
      "93": {
        start: {
          line: 332,
          column: 19
        },
        end: {
          line: 332,
          column: 42
        }
      },
      "94": {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 345,
          column: 5
        }
      },
      "95": {
        start: {
          line: 335,
          column: 18
        },
        end: {
          line: 335,
          column: 86
        }
      },
      "96": {
        start: {
          line: 335,
          column: 39
        },
        end: {
          line: 335,
          column: 60
        }
      },
      "97": {
        start: {
          line: 335,
          column: 74
        },
        end: {
          line: 335,
          column: 85
        }
      },
      "98": {
        start: {
          line: 337,
          column: 6
        },
        end: {
          line: 339,
          column: 7
        }
      },
      "99": {
        start: {
          line: 338,
          column: 8
        },
        end: {
          line: 338,
          column: 38
        }
      },
      "100": {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 343,
          column: 7
        }
      },
      "101": {
        start: {
          line: 342,
          column: 8
        },
        end: {
          line: 342,
          column: 63
        }
      },
      "102": {
        start: {
          line: 344,
          column: 6
        },
        end: {
          line: 344,
          column: 18
        }
      },
      "103": {
        start: {
          line: 346,
          column: 20
        },
        end: {
          line: 346,
          column: 47
        }
      },
      "104": {
        start: {
          line: 347,
          column: 4
        },
        end: {
          line: 349,
          column: 5
        }
      },
      "105": {
        start: {
          line: 348,
          column: 6
        },
        end: {
          line: 348,
          column: 87
        }
      },
      "106": {
        start: {
          line: 351,
          column: 14
        },
        end: {
          line: 351,
          column: 70
        }
      },
      "107": {
        start: {
          line: 352,
          column: 18
        },
        end: {
          line: 352,
          column: 45
        }
      },
      "108": {
        start: {
          line: 354,
          column: 4
        },
        end: {
          line: 362,
          column: 5
        }
      },
      "109": {
        start: {
          line: 366,
          column: 48
        },
        end: {
          line: 366,
          column: 58
        }
      },
      "110": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 367,
          column: 60
        }
      },
      "111": {
        start: {
          line: 367,
          column: 49
        },
        end: {
          line: 367,
          column: 60
        }
      },
      "112": {
        start: {
          line: 368,
          column: 22
        },
        end: {
          line: 368,
          column: 31
        }
      },
      "113": {
        start: {
          line: 370,
          column: 4
        },
        end: {
          line: 374,
          column: 5
        }
      },
      "114": {
        start: {
          line: 378,
          column: 56
        },
        end: {
          line: 378,
          column: 66
        }
      },
      "115": {
        start: {
          line: 379,
          column: 28
        },
        end: {
          line: 379,
          column: 48
        }
      },
      "116": {
        start: {
          line: 380,
          column: 24
        },
        end: {
          line: 380,
          column: 63
        }
      },
      "117": {
        start: {
          line: 381,
          column: 19
        },
        end: {
          line: 381,
          column: 63
        }
      },
      "118": {
        start: {
          line: 383,
          column: 16
        },
        end: {
          line: 383,
          column: 23
        }
      },
      "119": {
        start: {
          line: 384,
          column: 20
        },
        end: {
          line: 384,
          column: 38
        }
      },
      "120": {
        start: {
          line: 385,
          column: 22
        },
        end: {
          line: 385,
          column: 44
        }
      },
      "121": {
        start: {
          line: 386,
          column: 18
        },
        end: {
          line: 386,
          column: 59
        }
      },
      "122": {
        start: {
          line: 387,
          column: 17
        },
        end: {
          line: 387,
          column: 56
        }
      },
      "123": {
        start: {
          line: 389,
          column: 4
        },
        end: {
          line: 411,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 29
          }
        },
        loc: {
          start: {
            line: 26,
            column: 116
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 26
          },
          end: {
            line: 37,
            column: 27
          }
        },
        loc: {
          start: {
            line: 41,
            column: 5
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 41
      },
      "2": {
        name: "Item",
        decl: {
          start: {
            line: 52,
            column: 9
          },
          end: {
            line: 52,
            column: 13
          }
        },
        loc: {
          start: {
            line: 70,
            column: 3
          },
          end: {
            line: 96,
            column: 1
          }
        },
        line: 70
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 51
          },
          end: {
            line: 76,
            column: 52
          }
        },
        loc: {
          start: {
            line: 76,
            column: 57
          },
          end: {
            line: 76,
            column: 70
          }
        },
        line: 76
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 47
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 109
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 22
          },
          end: {
            line: 126,
            column: 3
          }
        },
        line: 121
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 128,
            column: 3
          }
        },
        loc: {
          start: {
            line: 128,
            column: 57
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 128
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 132,
            column: 3
          }
        },
        loc: {
          start: {
            line: 132,
            column: 25
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 132
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 3
          }
        },
        loc: {
          start: {
            line: 136,
            column: 23
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 136
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        loc: {
          start: {
            line: 144,
            column: 22
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 144
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 149,
            column: 2
          },
          end: {
            line: 149,
            column: 3
          }
        },
        loc: {
          start: {
            line: 149,
            column: 33
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 149
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 3
          }
        },
        loc: {
          start: {
            line: 153,
            column: 49
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 153
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 14
          },
          end: {
            line: 181,
            column: 3
          }
        },
        line: 175
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 183,
            column: 3
          }
        },
        loc: {
          start: {
            line: 183,
            column: 31
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 183
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 185,
            column: 15
          },
          end: {
            line: 185,
            column: 16
          }
        },
        loc: {
          start: {
            line: 185,
            column: 21
          },
          end: {
            line: 187,
            column: 5
          }
        },
        line: 185
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 18
          },
          end: {
            line: 200,
            column: 3
          }
        },
        line: 190
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 194,
            column: 23
          },
          end: {
            line: 194,
            column: 24
          }
        },
        loc: {
          start: {
            line: 194,
            column: 31
          },
          end: {
            line: 198,
            column: 7
          }
        },
        line: 194
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        loc: {
          start: {
            line: 202,
            column: 27
          },
          end: {
            line: 204,
            column: 3
          }
        },
        line: 202
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 206,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        },
        loc: {
          start: {
            line: 206,
            column: 40
          },
          end: {
            line: 223,
            column: 3
          }
        },
        line: 206
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 216,
            column: 20
          },
          end: {
            line: 216,
            column: 21
          }
        },
        loc: {
          start: {
            line: 216,
            column: 28
          },
          end: {
            line: 216,
            column: 81
          }
        },
        line: 216
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 217,
            column: 20
          },
          end: {
            line: 217,
            column: 21
          }
        },
        loc: {
          start: {
            line: 217,
            column: 28
          },
          end: {
            line: 217,
            column: 48
          }
        },
        line: 217
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 225,
            column: 2
          },
          end: {
            line: 225,
            column: 3
          }
        },
        loc: {
          start: {
            line: 225,
            column: 39
          },
          end: {
            line: 243,
            column: 3
          }
        },
        line: 225
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 245,
            column: 3
          }
        },
        loc: {
          start: {
            line: 245,
            column: 16
          },
          end: {
            line: 258,
            column: 3
          }
        },
        line: 245
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 260,
            column: 2
          },
          end: {
            line: 260,
            column: 3
          }
        },
        loc: {
          start: {
            line: 260,
            column: 69
          },
          end: {
            line: 294,
            column: 3
          }
        },
        line: 260
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 296,
            column: 2
          },
          end: {
            line: 296,
            column: 3
          }
        },
        loc: {
          start: {
            line: 296,
            column: 37
          },
          end: {
            line: 317,
            column: 3
          }
        },
        line: 296
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 319,
            column: 2
          },
          end: {
            line: 319,
            column: 3
          }
        },
        loc: {
          start: {
            line: 319,
            column: 17
          },
          end: {
            line: 363,
            column: 3
          }
        },
        line: 319
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 335,
            column: 29
          },
          end: {
            line: 335,
            column: 30
          }
        },
        loc: {
          start: {
            line: 335,
            column: 39
          },
          end: {
            line: 335,
            column: 60
          }
        },
        line: 335
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 335,
            column: 69
          },
          end: {
            line: 335,
            column: 70
          }
        },
        loc: {
          start: {
            line: 335,
            column: 74
          },
          end: {
            line: 335,
            column: 85
          }
        },
        line: 335
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 365,
            column: 2
          },
          end: {
            line: 365,
            column: 3
          }
        },
        loc: {
          start: {
            line: 365,
            column: 20
          },
          end: {
            line: 375,
            column: 3
          }
        },
        line: 365
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 377,
            column: 2
          },
          end: {
            line: 377,
            column: 3
          }
        },
        loc: {
          start: {
            line: 377,
            column: 11
          },
          end: {
            line: 412,
            column: 3
          }
        },
        line: 377
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 77
          },
          end: {
            line: 29,
            column: 96
          }
        }, {
          start: {
            line: 29,
            column: 99
          },
          end: {
            line: 29,
            column: 112
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 36
          }
        }, {
          start: {
            line: 29,
            column: 40
          },
          end: {
            line: 29,
            column: 74
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }],
        line: 31
      },
      "4": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }, {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }],
        line: 44
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 29
          }
        }, {
          start: {
            line: 44,
            column: 33
          },
          end: {
            line: 44,
            column: 67
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 90
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 90
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 90
          }
        }],
        line: 45
      },
      "7": {
        loc: {
          start: {
            line: 46,
            column: 11
          },
          end: {
            line: 46,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 43
          },
          end: {
            line: 46,
            column: 76
          }
        }, {
          start: {
            line: 46,
            column: 79
          },
          end: {
            line: 46,
            column: 98
          }
        }],
        line: 46
      },
      "8": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 59,
            column: 15
          }
        }],
        line: 59
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 32
          }
        }, {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 32
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 39
          },
          end: {
            line: 76,
            column: 48
          }
        }, {
          start: {
            line: 76,
            column: 51
          },
          end: {
            line: 76,
            column: 70
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 24
          }
        }, {
          start: {
            line: 76,
            column: 28
          },
          end: {
            line: 76,
            column: 36
          }
        }],
        line: 76
      },
      "12": {
        loc: {
          start: {
            line: 77,
            column: 22
          },
          end: {
            line: 77,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 22
          },
          end: {
            line: 77,
            column: 30
          }
        }, {
          start: {
            line: 77,
            column: 34
          },
          end: {
            line: 77,
            column: 40
          }
        }],
        line: 77
      },
      "13": {
        loc: {
          start: {
            line: 80,
            column: 13
          },
          end: {
            line: 80,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 42
          },
          end: {
            line: 80,
            column: 49
          }
        }, {
          start: {
            line: 80,
            column: 52
          },
          end: {
            line: 80,
            column: 61
          }
        }],
        line: 80
      },
      "14": {
        loc: {
          start: {
            line: 80,
            column: 13
          },
          end: {
            line: 80,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 13
          },
          end: {
            line: 80,
            column: 18
          }
        }, {
          start: {
            line: 80,
            column: 22
          },
          end: {
            line: 80,
            column: 39
          }
        }],
        line: 80
      },
      "15": {
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 18
          }
        }, {
          start: {
            line: 85,
            column: 22
          },
          end: {
            line: 85,
            column: 51
          }
        }],
        line: 85
      },
      "16": {
        loc: {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 86,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 86,
            column: 21
          }
        }, {
          start: {
            line: 86,
            column: 25
          },
          end: {
            line: 86,
            column: 49
          }
        }],
        line: 86
      },
      "17": {
        loc: {
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 14
          }
        }, {
          start: {
            line: 87,
            column: 18
          },
          end: {
            line: 87,
            column: 29
          }
        }],
        line: 87
      },
      "18": {
        loc: {
          start: {
            line: 93,
            column: 7
          },
          end: {
            line: 93,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 7
          },
          end: {
            line: 93,
            column: 19
          }
        }, {
          start: {
            line: 93,
            column: 23
          },
          end: {
            line: 93,
            column: 93
          }
        }],
        line: 93
      },
      "19": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }],
        line: 123
      },
      "20": {
        loc: {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 123,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 123,
            column: 18
          }
        }, {
          start: {
            line: 123,
            column: 22
          },
          end: {
            line: 123,
            column: 47
          }
        }],
        line: 123
      },
      "21": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 62
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 62
          }
        }],
        line: 133
      },
      "22": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }],
        line: 138
      },
      "23": {
        loc: {
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 26
          }
        }, {
          start: {
            line: 146,
            column: 30
          },
          end: {
            line: 146,
            column: 55
          }
        }, {
          start: {
            line: 146,
            column: 59
          },
          end: {
            line: 146,
            column: 79
          }
        }],
        line: 146
      },
      "24": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }],
        line: 156
      },
      "25": {
        loc: {
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 42
          }
        }, {
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 42
          }
        }],
        line: 157
      },
      "26": {
        loc: {
          start: {
            line: 159,
            column: 25
          },
          end: {
            line: 159,
            column: 119
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 25
          },
          end: {
            line: 159,
            column: 63
          }
        }, {
          start: {
            line: 159,
            column: 67
          },
          end: {
            line: 159,
            column: 119
          }
        }],
        line: 159
      },
      "27": {
        loc: {
          start: {
            line: 159,
            column: 68
          },
          end: {
            line: 159,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 68
          },
          end: {
            line: 159,
            column: 72
          }
        }, {
          start: {
            line: 159,
            column: 76
          },
          end: {
            line: 159,
            column: 78
          }
        }],
        line: 159
      },
      "28": {
        loc: {
          start: {
            line: 159,
            column: 92
          },
          end: {
            line: 159,
            column: 111
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 92
          },
          end: {
            line: 159,
            column: 105
          }
        }, {
          start: {
            line: 159,
            column: 109
          },
          end: {
            line: 159,
            column: 111
          }
        }],
        line: 159
      },
      "29": {
        loc: {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }, {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }],
        line: 160
      },
      "30": {
        loc: {
          start: {
            line: 162,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        }, {
          start: {
            line: 162,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        }],
        line: 162
      },
      "31": {
        loc: {
          start: {
            line: 162,
            column: 17
          },
          end: {
            line: 162,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 17
          },
          end: {
            line: 162,
            column: 38
          }
        }, {
          start: {
            line: 162,
            column: 42
          },
          end: {
            line: 162,
            column: 62
          }
        }],
        line: 162
      },
      "32": {
        loc: {
          start: {
            line: 162,
            column: 18
          },
          end: {
            line: 162,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 18
          },
          end: {
            line: 162,
            column: 24
          }
        }, {
          start: {
            line: 162,
            column: 28
          },
          end: {
            line: 162,
            column: 30
          }
        }],
        line: 162
      },
      "33": {
        loc: {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 38
          }
        }, {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 38
          }
        }],
        line: 176
      },
      "34": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 39
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 39
          }
        }],
        line: 192
      },
      "35": {
        loc: {
          start: {
            line: 208,
            column: 4
          },
          end: {
            line: 208,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 4
          },
          end: {
            line: 208,
            column: 35
          }
        }, {
          start: {
            line: 208,
            column: 4
          },
          end: {
            line: 208,
            column: 35
          }
        }],
        line: 208
      },
      "36": {
        loc: {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        }, {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        }],
        line: 247
      },
      "37": {
        loc: {
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 247,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 247,
            column: 15
          }
        }, {
          start: {
            line: 247,
            column: 19
          },
          end: {
            line: 247,
            column: 25
          }
        }, {
          start: {
            line: 247,
            column: 29
          },
          end: {
            line: 247,
            column: 42
          }
        }, {
          start: {
            line: 247,
            column: 46
          },
          end: {
            line: 247,
            column: 63
          }
        }],
        line: 247
      },
      "38": {
        loc: {
          start: {
            line: 260,
            column: 37
          },
          end: {
            line: 260,
            column: 67
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 260,
            column: 60
          },
          end: {
            line: 260,
            column: 67
          }
        }],
        line: 260
      },
      "39": {
        loc: {
          start: {
            line: 277,
            column: 23
          },
          end: {
            line: 277,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 277,
            column: 31
          },
          end: {
            line: 277,
            column: 32
          }
        }, {
          start: {
            line: 277,
            column: 35
          },
          end: {
            line: 277,
            column: 36
          }
        }],
        line: 277
      },
      "40": {
        loc: {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 301,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 301,
            column: 5
          }
        }, {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 301,
            column: 5
          }
        }],
        line: 299
      },
      "41": {
        loc: {
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 299,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 299,
            column: 13
          }
        }, {
          start: {
            line: 299,
            column: 17
          },
          end: {
            line: 299,
            column: 25
          }
        }, {
          start: {
            line: 299,
            column: 29
          },
          end: {
            line: 299,
            column: 34
          }
        }],
        line: 299
      },
      "42": {
        loc: {
          start: {
            line: 300,
            column: 30
          },
          end: {
            line: 300,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 300,
            column: 41
          },
          end: {
            line: 300,
            column: 51
          }
        }, {
          start: {
            line: 300,
            column: 54
          },
          end: {
            line: 300,
            column: 56
          }
        }],
        line: 300
      },
      "43": {
        loc: {
          start: {
            line: 306,
            column: 15
          },
          end: {
            line: 306,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 306,
            column: 24
          },
          end: {
            line: 306,
            column: 43
          }
        }, {
          start: {
            line: 306,
            column: 46
          },
          end: {
            line: 306,
            column: 55
          }
        }],
        line: 306
      },
      "44": {
        loc: {
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 310,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 310,
            column: 20
          }
        }, {
          start: {
            line: 310,
            column: 24
          },
          end: {
            line: 310,
            column: 50
          }
        }],
        line: 310
      },
      "45": {
        loc: {
          start: {
            line: 332,
            column: 19
          },
          end: {
            line: 332,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 19
          },
          end: {
            line: 332,
            column: 36
          }
        }, {
          start: {
            line: 332,
            column: 40
          },
          end: {
            line: 332,
            column: 42
          }
        }],
        line: 332
      },
      "46": {
        loc: {
          start: {
            line: 334,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 334,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }, {
          start: {
            line: 334,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }],
        line: 334
      },
      "47": {
        loc: {
          start: {
            line: 337,
            column: 6
          },
          end: {
            line: 339,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 337,
            column: 6
          },
          end: {
            line: 339,
            column: 7
          }
        }, {
          start: {
            line: 337,
            column: 6
          },
          end: {
            line: 339,
            column: 7
          }
        }],
        line: 337
      },
      "48": {
        loc: {
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 343,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 343,
            column: 7
          }
        }, {
          start: {
            line: 341,
            column: 6
          },
          end: {
            line: 343,
            column: 7
          }
        }],
        line: 341
      },
      "49": {
        loc: {
          start: {
            line: 341,
            column: 10
          },
          end: {
            line: 341,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 341,
            column: 10
          },
          end: {
            line: 341,
            column: 15
          }
        }, {
          start: {
            line: 341,
            column: 19
          },
          end: {
            line: 341,
            column: 27
          }
        }],
        line: 341
      },
      "50": {
        loc: {
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 349,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 349,
            column: 5
          }
        }, {
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 349,
            column: 5
          }
        }],
        line: 347
      },
      "51": {
        loc: {
          start: {
            line: 352,
            column: 18
          },
          end: {
            line: 352,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 352,
            column: 32
          },
          end: {
            line: 352,
            column: 33
          }
        }, {
          start: {
            line: 352,
            column: 36
          },
          end: {
            line: 352,
            column: 45
          }
        }],
        line: 352
      },
      "52": {
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 60
          }
        }, {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 60
          }
        }],
        line: 367
      },
      "53": {
        loc: {
          start: {
            line: 367,
            column: 8
          },
          end: {
            line: 367,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 367,
            column: 8
          },
          end: {
            line: 367,
            column: 18
          }
        }, {
          start: {
            line: 367,
            column: 23
          },
          end: {
            line: 367,
            column: 31
          }
        }, {
          start: {
            line: 367,
            column: 35
          },
          end: {
            line: 367,
            column: 46
          }
        }],
        line: 367
      },
      "54": {
        loc: {
          start: {
            line: 371,
            column: 75
          },
          end: {
            line: 371,
            column: 103
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 371,
            column: 86
          },
          end: {
            line: 371,
            column: 93
          }
        }, {
          start: {
            line: 371,
            column: 96
          },
          end: {
            line: 371,
            column: 103
          }
        }],
        line: 371
      },
      "55": {
        loc: {
          start: {
            line: 372,
            column: 9
          },
          end: {
            line: 372,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 372,
            column: 9
          },
          end: {
            line: 372,
            column: 18
          }
        }, {
          start: {
            line: 372,
            column: 22
          },
          end: {
            line: 372,
            column: 31
          }
        }],
        line: 372
      },
      "56": {
        loc: {
          start: {
            line: 381,
            column: 19
          },
          end: {
            line: 381,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 381,
            column: 37
          },
          end: {
            line: 381,
            column: 41
          }
        }, {
          start: {
            line: 381,
            column: 44
          },
          end: {
            line: 381,
            column: 63
          }
        }],
        line: 381
      },
      "57": {
        loc: {
          start: {
            line: 387,
            column: 17
          },
          end: {
            line: 387,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 18
          },
          end: {
            line: 387,
            column: 26
          }
        }, {
          start: {
            line: 387,
            column: 30
          },
          end: {
            line: 387,
            column: 35
          }
        }, {
          start: {
            line: 387,
            column: 40
          },
          end: {
            line: 387,
            column: 56
          }
        }],
        line: 387
      },
      "58": {
        loc: {
          start: {
            line: 401,
            column: 14
          },
          end: {
            line: 401,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 401,
            column: 14
          },
          end: {
            line: 401,
            column: 24
          }
        }, {
          start: {
            line: 401,
            column: 28
          },
          end: {
            line: 401,
            column: 40
          }
        }],
        line: 401
      },
      "59": {
        loc: {
          start: {
            line: 402,
            column: 14
          },
          end: {
            line: 402,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 402,
            column: 14
          },
          end: {
            line: 402,
            column: 29
          }
        }, {
          start: {
            line: 402,
            column: 33
          },
          end: {
            line: 402,
            column: 40
          }
        }],
        line: 402
      },
      "60": {
        loc: {
          start: {
            line: 403,
            column: 14
          },
          end: {
            line: 403,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 403,
            column: 14
          },
          end: {
            line: 403,
            column: 21
          }
        }, {
          start: {
            line: 403,
            column: 25
          },
          end: {
            line: 403,
            column: 43
          }
        }],
        line: 403
      },
      "61": {
        loc: {
          start: {
            line: 405,
            column: 12
          },
          end: {
            line: 405,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 405,
            column: 12
          },
          end: {
            line: 405,
            column: 22
          }
        }, {
          start: {
            line: 405,
            column: 26
          },
          end: {
            line: 405,
            column: 83
          }
        }],
        line: 405
      },
      "62": {
        loc: {
          start: {
            line: 408,
            column: 11
          },
          end: {
            line: 408,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 408,
            column: 17
          },
          end: {
            line: 408,
            column: 32
          }
        }, {
          start: {
            line: 408,
            column: 35
          },
          end: {
            line: 408,
            column: 40
          }
        }],
        line: 408
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0, 0, 0],
      "38": [0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/Result.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { selectClass } from './styles';
import { inputClass } from '../Input/styles';
import { inputTitleClass } from '../InputTitle/styles';
import { isObject, isFunc, isString, isEmpty, isNumber } from '../utils/is';
import { addResizeObserver } from '../utils/dom/element';
import Input from './Input';
import Caret from '../icons/Caret';
import { isRTL } from '../config';
import More, { getResetMore } from './More';
import InputTitle from '../InputTitle';
import { getDirectionClass } from '../utils/classname';
import ShallowEqual from '../utils/shallowEqual';
export var IS_NOT_MATCHED_VALUE = (cov_2b2nsm30fd.s[0]++, 'IS_NOT_MATCHED_VALUE');
/**
 * get result className from resultClassName attr
 * @param {function | string} f props => resultClassName
 * @param {any} value result value
 * @returns {string | null}
 */

cov_2b2nsm30fd.s[1]++;

var getResultClassName = function getResultClassName(f, data) {
  cov_2b2nsm30fd.f[0]++;
  var unMatchedData = (cov_2b2nsm30fd.s[2]++, data);
  cov_2b2nsm30fd.s[3]++;

  if (isFunc(f)) {
    cov_2b2nsm30fd.b[0][0]++;
    cov_2b2nsm30fd.s[4]++;
    return f((cov_2b2nsm30fd.b[2][0]++, isObject(unMatchedData)) && (cov_2b2nsm30fd.b[2][1]++, unMatchedData.IS_NOT_MATCHED_VALUE) ? (cov_2b2nsm30fd.b[1][0]++, unMatchedData.value) : (cov_2b2nsm30fd.b[1][1]++, unMatchedData));
  } else {
    cov_2b2nsm30fd.b[0][1]++;
  }

  cov_2b2nsm30fd.s[5]++;

  if (isString(f)) {
    cov_2b2nsm30fd.b[3][0]++;
    cov_2b2nsm30fd.s[6]++;
    return f;
  } else {
    cov_2b2nsm30fd.b[3][1]++;
  }

  cov_2b2nsm30fd.s[7]++;
  return null;
};

cov_2b2nsm30fd.s[8]++;

var getResultContent = function getResultContent(data, renderResult, renderUnmatched) {
  cov_2b2nsm30fd.f[1]++;
  var unMatchedData = (cov_2b2nsm30fd.s[9]++, data);
  cov_2b2nsm30fd.s[10]++;

  if ((cov_2b2nsm30fd.b[5][0]++, isObject(unMatchedData)) && (cov_2b2nsm30fd.b[5][1]++, unMatchedData.IS_NOT_MATCHED_VALUE)) {
    cov_2b2nsm30fd.b[4][0]++;
    cov_2b2nsm30fd.s[11]++;

    if (typeof renderUnmatched === 'function') {
      cov_2b2nsm30fd.b[6][0]++;
      cov_2b2nsm30fd.s[12]++;
      return renderUnmatched(unMatchedData.value);
    } else {
      cov_2b2nsm30fd.b[6][1]++;
    }

    cov_2b2nsm30fd.s[13]++;
    return isObject(unMatchedData.value) ? (cov_2b2nsm30fd.b[7][0]++, renderResult(unMatchedData.value)) : (cov_2b2nsm30fd.b[7][1]++, unMatchedData.value);
  } else {
    cov_2b2nsm30fd.b[4][1]++;
  }

  cov_2b2nsm30fd.s[14]++;
  return renderResult(data);
}; // eslint-disable-next-line


function Item(_ref) {
  var isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      resultClassName = _ref.resultClassName,
      value = _ref.value,
      getDataByValue = _ref.getDataByValue,
      getContent = _ref.getContent,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? (cov_2b2nsm30fd.b[8][0]++, false) : _ref$title,
      only = _ref.only;
  cov_2b2nsm30fd.f[2]++;
  var data = (cov_2b2nsm30fd.s[15]++, getDataByValue(value));
  cov_2b2nsm30fd.s[16]++;

  if (data === null) {
    cov_2b2nsm30fd.b[9][0]++;
    cov_2b2nsm30fd.s[17]++;
    return null;
  } else {
    cov_2b2nsm30fd.b[9][1]++;
  }

  var content = (cov_2b2nsm30fd.s[18]++, getContent(data));
  var disabled = (cov_2b2nsm30fd.s[19]++, isDisabled(data));
  var click = (cov_2b2nsm30fd.s[20]++, (cov_2b2nsm30fd.b[11][0]++, disabled) || (cov_2b2nsm30fd.b[11][1]++, !onClick) ? (cov_2b2nsm30fd.b[10][0]++, undefined) : (cov_2b2nsm30fd.b[10][1]++, function () {
    cov_2b2nsm30fd.f[3]++;
    cov_2b2nsm30fd.s[21]++;
    return onClick(data);
  }));
  var synDisabled = (cov_2b2nsm30fd.s[22]++, (cov_2b2nsm30fd.b[12][0]++, disabled) || (cov_2b2nsm30fd.b[12][1]++, !click));
  cov_2b2nsm30fd.s[23]++;
  return (
    /*#__PURE__*/
    React.createElement("a", {
      title: (cov_2b2nsm30fd.b[14][0]++, title) && (cov_2b2nsm30fd.b[14][1]++, isString(content)) ? (cov_2b2nsm30fd.b[13][0]++, content) : (cov_2b2nsm30fd.b[13][1]++, undefined),
      tabIndex: -1,
      className: classnames(selectClass(getDirectionClass('item'), (cov_2b2nsm30fd.b[15][0]++, disabled) && (cov_2b2nsm30fd.b[15][1]++, getDirectionClass('disabled')), (cov_2b2nsm30fd.b[16][0]++, synDisabled) && (cov_2b2nsm30fd.b[16][1]++, getDirectionClass('ban')), (cov_2b2nsm30fd.b[17][0]++, only) && (cov_2b2nsm30fd.b[17][1]++, 'item-only')), getResultClassName(resultClassName, data)),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 5
      }
    }, content, (cov_2b2nsm30fd.b[18][0]++, !synDisabled) && (cov_2b2nsm30fd.b[18][1]++,
    /*#__PURE__*/
    React.createElement("span", {
      className: selectClass('indicator', 'close'),
      onClick: click,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 24
      }
    })))
  );
}

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    cov_2b2nsm30fd.f[4]++;
    cov_2b2nsm30fd.s[24]++;
    _this = _super.call(this, props);
    _this.resultEl = void 0;
    _this.cancelResizeObserver = void 0;
    _this.shouldResetMore = void 0;
    cov_2b2nsm30fd.s[25]++;
    _this.state = {
      more: -1
    };
    cov_2b2nsm30fd.s[26]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    cov_2b2nsm30fd.s[27]++;
    _this.handelMore = _this.handelMore.bind(_assertThisInitialized(_this));
    cov_2b2nsm30fd.s[28]++;
    _this.bindResult = _this.bindResult.bind(_assertThisInitialized(_this));
    cov_2b2nsm30fd.s[29]++;
    _this.resetMore = _this.resetMore.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2b2nsm30fd.f[5]++;

      var _ref2 = (cov_2b2nsm30fd.s[30]++, this.props),
          compressed = _ref2.compressed;

      cov_2b2nsm30fd.s[31]++;

      if ((cov_2b2nsm30fd.b[20][0]++, compressed) && (cov_2b2nsm30fd.b[20][1]++, !this.isCompressedBound())) {
        cov_2b2nsm30fd.b[19][0]++;
        cov_2b2nsm30fd.s[32]++;
        this.cancelResizeObserver = addResizeObserver(this.resultEl, this.resetMore, {
          direction: 'x'
        });
      } else {
        cov_2b2nsm30fd.b[19][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      cov_2b2nsm30fd.f[6]++;
      cov_2b2nsm30fd.s[33]++;
      this.updateMore(preProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2b2nsm30fd.f[7]++;
      cov_2b2nsm30fd.s[34]++;

      if (this.cancelResizeObserver) {
        cov_2b2nsm30fd.b[21][0]++;
        cov_2b2nsm30fd.s[35]++;
        this.cancelResizeObserver();
      } else {
        cov_2b2nsm30fd.b[21][1]++;
      }
    }
  }, {
    key: "getCompressedBound",
    value: function getCompressedBound() {
      cov_2b2nsm30fd.f[8]++;

      var _ref3 = (cov_2b2nsm30fd.s[36]++, this.props),
          compressedBound = _ref3.compressedBound;

      cov_2b2nsm30fd.s[37]++;

      if (this.isCompressedBound()) {
        cov_2b2nsm30fd.b[22][0]++;
        cov_2b2nsm30fd.s[38]++;
        return compressedBound;
      } else {
        cov_2b2nsm30fd.b[22][1]++;
      }

      cov_2b2nsm30fd.s[39]++;
      return this.state.more;
    }
  }, {
    key: "isCompressedBound",
    value: function isCompressedBound() {
      cov_2b2nsm30fd.f[9]++;

      var _ref4 = (cov_2b2nsm30fd.s[40]++, this.props),
          compressedBound = _ref4.compressedBound;

      cov_2b2nsm30fd.s[41]++;
      return (cov_2b2nsm30fd.b[23][0]++, compressedBound) && (cov_2b2nsm30fd.b[23][1]++, isNumber(compressedBound)) && (cov_2b2nsm30fd.b[23][2]++, compressedBound >= 1);
    }
  }, {
    key: "bindResult",
    value: function bindResult(el) {
      cov_2b2nsm30fd.f[10]++;
      cov_2b2nsm30fd.s[42]++;
      this.resultEl = el;
    }
  }, {
    key: "updateMore",
    value: function updateMore(preProps) {
      cov_2b2nsm30fd.f[11]++;

      var _ref5 = (cov_2b2nsm30fd.s[43]++, this.props),
          compressed = _ref5.compressed,
          onFilter = _ref5.onFilter,
          values = _ref5.values,
          data = _ref5.data;

      cov_2b2nsm30fd.s[44]++;

      if (compressed) {
        cov_2b2nsm30fd.b[24][0]++;
        cov_2b2nsm30fd.s[45]++;

        if (this.isCompressedBound()) {
          cov_2b2nsm30fd.b[25][0]++;
          cov_2b2nsm30fd.s[46]++;
          return;
        } else {
          cov_2b2nsm30fd.b[25][1]++;
        }

        var shouldRest = (cov_2b2nsm30fd.s[47]++, (cov_2b2nsm30fd.b[26][0]++, !ShallowEqual(preProps.values, values)) || (cov_2b2nsm30fd.b[26][1]++, ((cov_2b2nsm30fd.b[27][0]++, data) || (cov_2b2nsm30fd.b[27][1]++, [])).length !== ((cov_2b2nsm30fd.b[28][0]++, preProps.data) || (cov_2b2nsm30fd.b[28][1]++, [])).length));
        cov_2b2nsm30fd.s[48]++;

        if (shouldRest) {
          cov_2b2nsm30fd.b[29][0]++;
          cov_2b2nsm30fd.s[49]++;
          this.resetMore();
        } else {
          cov_2b2nsm30fd.b[29][1]++;
          cov_2b2nsm30fd.s[50]++;

          if ((cov_2b2nsm30fd.b[31][0]++, ((cov_2b2nsm30fd.b[32][0]++, values) || (cov_2b2nsm30fd.b[32][1]++, [])).length) && (cov_2b2nsm30fd.b[31][1]++, this.shouldResetMore)) {
            cov_2b2nsm30fd.b[30][0]++;
            cov_2b2nsm30fd.s[51]++;
            this.shouldResetMore = false; // @ts-ignore

            cov_2b2nsm30fd.s[52]++;
            this.state.more = getResetMore(onFilter, this.resultEl, this.resultEl.querySelectorAll(".".concat(selectClass('item'))));
            cov_2b2nsm30fd.s[53]++;
            this.forceUpdate();
          } else {
            cov_2b2nsm30fd.b[30][1]++;
          }
        }
      } else {
        cov_2b2nsm30fd.b[24][1]++;
      }
    }
  }, {
    key: "resetMore",
    value: function resetMore() {
      cov_2b2nsm30fd.f[12]++;
      cov_2b2nsm30fd.s[54]++;

      if (!this.props.compressed) {
        cov_2b2nsm30fd.b[33][0]++;
        cov_2b2nsm30fd.s[55]++;
        return;
      } else {
        cov_2b2nsm30fd.b[33][1]++;
      }

      cov_2b2nsm30fd.s[56]++;
      this.shouldResetMore = true; // @ts-ignore

      cov_2b2nsm30fd.s[57]++;
      this.state.more = -1;
      cov_2b2nsm30fd.s[58]++;
      this.forceUpdate();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      cov_2b2nsm30fd.f[13]++;

      var _ref6 = (cov_2b2nsm30fd.s[59]++, this.props),
          onRemove = _ref6.onRemove;

      cov_2b2nsm30fd.s[60]++;
      setTimeout(function () {
        cov_2b2nsm30fd.f[14]++;
        cov_2b2nsm30fd.s[61]++;
        onRemove.apply(void 0, args);
      }, 10);
    }
  }, {
    key: "isEmptyResult",
    value: function isEmptyResult() {
      cov_2b2nsm30fd.f[15]++;

      var _ref7 = (cov_2b2nsm30fd.s[62]++, this.props),
          values = _ref7.values,
          renderResult = _ref7.renderResult,
          renderUnmatched = _ref7.renderUnmatched,
          getResultByValue = _ref7.getResultByValue;

      cov_2b2nsm30fd.s[63]++;

      if (values.length <= 0) {
        cov_2b2nsm30fd.b[34][0]++;
        cov_2b2nsm30fd.s[64]++;
        return true;
      } else {
        cov_2b2nsm30fd.b[34][1]++;
      }

      var hasValue = (cov_2b2nsm30fd.s[65]++, values.findIndex(function (item) {
        cov_2b2nsm30fd.f[16]++;
        var cur = (cov_2b2nsm30fd.s[66]++, getResultByValue(item));
        var r = (cov_2b2nsm30fd.s[67]++, getResultContent(cur, renderResult, renderUnmatched));
        cov_2b2nsm30fd.s[68]++;
        return !isEmpty(r);
      }) >= 0);
      cov_2b2nsm30fd.s[69]++;
      return !hasValue;
    }
  }, {
    key: "handelMore",
    value: function handelMore(more) {
      cov_2b2nsm30fd.f[17]++;
      cov_2b2nsm30fd.s[70]++;
      this.setState({
        more: more
      });
    }
  }, {
    key: "renderItem",
    value: function renderItem(value, index) {
      cov_2b2nsm30fd.f[18]++;

      var _ref8 = (cov_2b2nsm30fd.s[71]++, this.props),
          renderResult = _ref8.renderResult,
          renderUnmatched = _ref8.renderUnmatched,
          datum = _ref8.datum,
          resultClassName = _ref8.resultClassName,
          getResultByValue = _ref8.getResultByValue;

      cov_2b2nsm30fd.s[72]++;

      if (value === null) {
        cov_2b2nsm30fd.b[35][0]++;
        cov_2b2nsm30fd.s[73]++;
        return null;
      } else {
        cov_2b2nsm30fd.b[35][1]++;
      }

      var more = (cov_2b2nsm30fd.s[74]++, this.getCompressedBound());
      cov_2b2nsm30fd.s[75]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          key: index,
          only: more === 1,
          value: value,
          getDataByValue: getResultByValue,
          getContent: function getContent(data) {
            cov_2b2nsm30fd.f[19]++;
            cov_2b2nsm30fd.s[76]++;
            return getResultContent(data, renderResult, renderUnmatched);
          },
          isDisabled: function isDisabled(data) {
            cov_2b2nsm30fd.f[20]++;
            cov_2b2nsm30fd.s[77]++;
            return datum.disabled(data);
          },
          onClick: this.handleRemove,
          resultClassName: resultClassName,
          title: true,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderMore",
    value: function renderMore(items) {
      cov_2b2nsm30fd.f[21]++;

      var _ref9 = (cov_2b2nsm30fd.s[78]++, this.props),
          compressedClassName = _ref9.compressedClassName,
          compressed = _ref9.compressed;

      var more = (cov_2b2nsm30fd.s[79]++, this.getCompressedBound());
      var className = (cov_2b2nsm30fd.s[80]++, classnames(selectClass('popover'), compressedClassName));
      cov_2b2nsm30fd.s[81]++;
      return [
      /*#__PURE__*/
      React.createElement(More, {
        key: "more",
        showNum: more,
        className: selectClass(getDirectionClass('item'), 'item-compressed'),
        popoverClassName: className,
        contentClassName: selectClass(getDirectionClass('result')),
        compressed: compressed,
        data: items,
        more: more,
        cls: selectClass,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 231,
          columnNumber: 7
        }
      })];
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      cov_2b2nsm30fd.f[22]++;

      var _ref10 = (cov_2b2nsm30fd.s[82]++, this.props),
          onClear = _ref10.onClear,
          disabled = _ref10.disabled,
          values = _ref10.values;

      cov_2b2nsm30fd.s[83]++;

      if ((cov_2b2nsm30fd.b[37][0]++, onClear) && (cov_2b2nsm30fd.b[37][1]++, values) && (cov_2b2nsm30fd.b[37][2]++, values.length) && (cov_2b2nsm30fd.b[37][3]++, disabled !== true)) {
        cov_2b2nsm30fd.b[36][0]++;
        cov_2b2nsm30fd.s[84]++;

        /* eslint-disable */
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: "clear",
            onClick: onClear,
            className: selectClass('close-warpper'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 250,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement("a", {
            tabIndex: -1,
            "data-role": "close",
            className: selectClass('indicator', 'close'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 251,
              columnNumber: 11
            }
          }))
        );
        /* eslint-enable */
      } else {
        cov_2b2nsm30fd.b[36][1]++;
      }

      cov_2b2nsm30fd.s[85]++;
      return null;
    }
  }, {
    key: "renderInput",
    value: function renderInput(text) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2b2nsm30fd.b[38][0]++, 'input');
      cov_2b2nsm30fd.f[23]++;

      var _ref11 = (cov_2b2nsm30fd.s[86]++, this.props),
          multiple = _ref11.multiple,
          onFilter = _ref11.onFilter,
          trim = _ref11.trim,
          focus = _ref11.focus,
          onInputFocus = _ref11.onInputFocus,
          onInputBlur = _ref11.onInputBlur,
          setInputReset = _ref11.setInputReset,
          focusSelected = _ref11.focusSelected,
          bindFocusInputFunc = _ref11.bindFocusInputFunc,
          maxLength = _ref11.maxLength,
          convertBr = _ref11.convertBr;

      cov_2b2nsm30fd.s[87]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          key: "".concat(key, ".").concat(focus ? (cov_2b2nsm30fd.b[39][0]++, 1) : (cov_2b2nsm30fd.b[39][1]++, 0)),
          onInputFocus: onInputFocus,
          onInputBlur: onInputBlur,
          updatAble: !multiple,
          multiple: multiple,
          focus: focus,
          text: text,
          trim: trim,
          onFilter: onFilter,
          setInputReset: setInputReset,
          focusSelected: focusSelected,
          bindFocusInputFunc: bindFocusInputFunc // collapse={collapse}
          ,
          maxLength: maxLength,
          convertBr: convertBr,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 276,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(empty) {
      cov_2b2nsm30fd.f[24]++;

      var _ref12 = (cov_2b2nsm30fd.s[88]++, this.props),
          focus = _ref12.focus,
          onFilter = _ref12.onFilter,
          filterText = _ref12.filterText,
          multiple = _ref12.multiple,
          innerTitle = _ref12.innerTitle;

      cov_2b2nsm30fd.s[89]++;

      if ((cov_2b2nsm30fd.b[41][0]++, focus) && (cov_2b2nsm30fd.b[41][1]++, onFilter) && (cov_2b2nsm30fd.b[41][2]++, empty)) {
        cov_2b2nsm30fd.b[40][0]++;
        cov_2b2nsm30fd.s[90]++;
        return this.renderInput(multiple ? (cov_2b2nsm30fd.b[42][0]++, filterText) : (cov_2b2nsm30fd.b[42][1]++, ''));
      } else {
        cov_2b2nsm30fd.b[40][1]++;
      }

      cov_2b2nsm30fd.s[91]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "placeholder",
          style: !empty ? (cov_2b2nsm30fd.b[43][0]++, {
            display: 'none'
          }) : (cov_2b2nsm30fd.b[43][1]++, undefined),
          className: classnames(inputClass('placeholder'), selectClass('ellipsis'), (cov_2b2nsm30fd.b[44][0]++, innerTitle) && (cov_2b2nsm30fd.b[44][1]++, inputTitleClass('hidable'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 304,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 313,
            columnNumber: 9
          }
        }, this.props.placeholder), "\xA0")
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this2 = this;

      cov_2b2nsm30fd.f[25]++;

      var _ref13 = (cov_2b2nsm30fd.s[92]++, this.props),
          multiple = _ref13.multiple,
          compressed = _ref13.compressed,
          renderResult = _ref13.renderResult,
          renderUnmatched = _ref13.renderUnmatched,
          onFilter = _ref13.onFilter,
          focus = _ref13.focus,
          filterText = _ref13.filterText,
          resultClassName = _ref13.resultClassName,
          getResultByValue = _ref13.getResultByValue;

      var values = (cov_2b2nsm30fd.s[93]++, (cov_2b2nsm30fd.b[45][0]++, this.props.values) || (cov_2b2nsm30fd.b[45][1]++, []));
      cov_2b2nsm30fd.s[94]++;

      if (multiple) {
        cov_2b2nsm30fd.b[46][0]++;
        var items = (cov_2b2nsm30fd.s[95]++, values.map(function (n, i) {
          cov_2b2nsm30fd.f[26]++;
          cov_2b2nsm30fd.s[96]++;
          return _this2.renderItem(n, i);
        }).filter(function (n) {
          cov_2b2nsm30fd.f[27]++;
          cov_2b2nsm30fd.s[97]++;
          return !isEmpty(n);
        }));
        cov_2b2nsm30fd.s[98]++;

        if (compressed) {
          cov_2b2nsm30fd.b[47][0]++;
          cov_2b2nsm30fd.s[99]++;
          items = this.renderMore(items);
        } else {
          cov_2b2nsm30fd.b[47][1]++;
        }

        cov_2b2nsm30fd.s[100]++;

        if ((cov_2b2nsm30fd.b[49][0]++, focus) && (cov_2b2nsm30fd.b[49][1]++, onFilter)) {
          cov_2b2nsm30fd.b[48][0]++;
          cov_2b2nsm30fd.s[101]++;
          items.push(this.renderInput(filterText, values.length));
        } else {
          cov_2b2nsm30fd.b[48][1]++;
        }

        cov_2b2nsm30fd.s[102]++;
        return items;
      } else {
        cov_2b2nsm30fd.b[46][1]++;
      }

      var result0 = (cov_2b2nsm30fd.s[103]++, getResultByValue(values[0]));
      cov_2b2nsm30fd.s[104]++;

      if (onFilter) {
        cov_2b2nsm30fd.b[50][0]++;
        cov_2b2nsm30fd.s[105]++;
        return this.renderInput(getResultContent(result0, renderResult, renderUnmatched));
      } else {
        cov_2b2nsm30fd.b[50][1]++;
      }

      var v = (cov_2b2nsm30fd.s[106]++, getResultContent(result0, renderResult, renderUnmatched));
      var title = (cov_2b2nsm30fd.s[107]++, isString(v) ? (cov_2b2nsm30fd.b[51][0]++, v) : (cov_2b2nsm30fd.b[51][1]++, undefined));
      cov_2b2nsm30fd.s[108]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "result",
          title: title,
          className: classnames(selectClass('ellipsis'), getResultClassName(resultClassName, result0)),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 355,
            columnNumber: 7
          }
        }, v)
      );
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      cov_2b2nsm30fd.f[28]++;

      var _ref14 = (cov_2b2nsm30fd.s[109]++, this.props),
          multiple = _ref14.multiple,
          showArrow = _ref14.showArrow,
          compressed = _ref14.compressed;

      cov_2b2nsm30fd.s[110]++;

      if ((cov_2b2nsm30fd.b[53][0]++, !showArrow) || (cov_2b2nsm30fd.b[53][1]++, multiple) && (cov_2b2nsm30fd.b[53][2]++, !compressed)) {
        cov_2b2nsm30fd.b[52][0]++;
        cov_2b2nsm30fd.s[111]++;
        return null;
      } else {
        cov_2b2nsm30fd.b[52][1]++;
      }

      var showCaret = (cov_2b2nsm30fd.s[112]++, !multiple); // eslint-disable-next-line

      cov_2b2nsm30fd.s[113]++;
      return (
        /*#__PURE__*/
        React.createElement("a", {
          key: "indicator",
          tabIndex: -1,
          className: selectClass('indicator', multiple ? (cov_2b2nsm30fd.b[54][0]++, 'multi') : (cov_2b2nsm30fd.b[54][1]++, 'caret')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 371,
            columnNumber: 7
          }
        }, (cov_2b2nsm30fd.b[55][0]++, showCaret) && (cov_2b2nsm30fd.b[55][1]++,
        /*#__PURE__*/
        React.createElement(Caret, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 372,
            columnNumber: 23
          }
        })))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_2b2nsm30fd.f[29]++;

      var _ref15 = (cov_2b2nsm30fd.s[114]++, this.props),
          compressed = _ref15.compressed,
          innerTitle = _ref15.innerTitle,
          focus = _ref15.focus,
          onFilter = _ref15.onFilter;

      var showPlaceholder = (cov_2b2nsm30fd.s[115]++, this.isEmptyResult());
      var placeholder = (cov_2b2nsm30fd.s[116]++, this.renderPlaceholder(showPlaceholder));
      var result = (cov_2b2nsm30fd.s[117]++, showPlaceholder ? (cov_2b2nsm30fd.b[56][0]++, null) : (cov_2b2nsm30fd.b[56][1]++, this.renderResult()));
      var rtl = (cov_2b2nsm30fd.s[118]++, isRTL());
      var clearEl = (cov_2b2nsm30fd.s[119]++, this.renderClear());
      var indicator = (cov_2b2nsm30fd.s[120]++, this.renderIndicator());
      var inner = (cov_2b2nsm30fd.s[121]++, [result, placeholder, indicator, clearEl]);
      var open = (cov_2b2nsm30fd.s[122]++, (cov_2b2nsm30fd.b[57][0]++, onFilter) && (cov_2b2nsm30fd.b[57][1]++, focus) || (cov_2b2nsm30fd.b[57][2]++, !showPlaceholder));
      cov_2b2nsm30fd.s[123]++;
      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          innerTitle: innerTitle,
          open: open,
          className: selectClass('title-box'),
          titleClass: selectClass(getDirectionClass('title-box-title')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 390,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindResult,
          className: classnames(selectClass(getDirectionClass('result'), (cov_2b2nsm30fd.b[58][0]++, compressed) && (cov_2b2nsm30fd.b[58][1]++, 'compressed'), (cov_2b2nsm30fd.b[59][0]++, showPlaceholder) && (cov_2b2nsm30fd.b[59][1]++, 'empty'), (cov_2b2nsm30fd.b[60][0]++, clearEl) && (cov_2b2nsm30fd.b[60][1]++, 'result-clearable')), (cov_2b2nsm30fd.b[61][0]++, innerTitle) && (cov_2b2nsm30fd.b[61][1]++, inputTitleClass(getDirectionClass('item'), 'item-scroll'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 396,
            columnNumber: 9
          }
        }, rtl ? (cov_2b2nsm30fd.b[62][0]++, inner.reverse()) : (cov_2b2nsm30fd.b[62][1]++, inner)))
      );
    }
  }]);

  return Result;
}(PureComponent);

export default Result;